export const EnvironmentConfig = {
  auth0: {
    domain: process.env.REACT_APP_AUTH0_DOMAIN || "",
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || "",
    loginUrl: window.location.origin + "/login",
    redirectUri: window.location.origin,
  },
  api: {
    baseUrl: process.env.REACT_APP_API_BASEURL || "",
  },
  etim: {
    imageBaseUrl: process.env.REACT_APP_OCCTOO_IMAGEBASEURL || "",
  },
  occtoo: {
    baseUrl: process.env.REACT_APP_OCCTOO_BASEURL || "",
    groupEndpoint: process.env.REACT_APP_OCCTOO_GROUPENDPOINT || "",
    classesEndpoint: process.env.REACT_APP_OCCTOO_CLASSENDPOINT || "",
    featureGroupEndpoint:
      process.env.REACT_APP_OCCTOO_FEATUREGROUPENDPOINT || "",
    featureEndpoint: process.env.REACT_APP_OCCTOO_FEATUREENDPOINT || "",
    valueEndpoint: process.env.REACT_APP_OCCTOO_VALUEENDPOINT || "",
    unitEndpoint: process.env.REACT_APP_OCCTOO_UNITENDPOINT || "",
    includedfeaturesEndpoint:
      process.env.REACT_APP_OCCTOO_INCLUDEDFEATURESENDPOINT || "",
  },
  amJob: {
    baseUrl: process.env.REACT_APP_AM_JOB_BASEURL,
    key: process.env.REACT_APP_AM_JOB_KEY,
  },
};
